export const REPORTS_PER_PAGE = 4;

export const SCROLL_CONFIG = { smooth: true, offset: -200 };

export const PRICE_REPORT_FREQUENCIES = ['weekly', 'monthly', 'quarterly'];

export const OPTIONS_ORDERING = {
  w: 0,
  m: 1,
  q: 2,
};

export const DEFAULT_DROPDOWN_OPTION = 'weekly';
